/* ============================================================
   VIDEO-001 - product-card video playback. 2026-07-29.
   RESTORED 2026-08-25: this file was lost entirely in the Palo Alto 9.2.0
   update, along with the <script> line in layout/theme.liquid that loads it.

   PROBLEM
   snippets/grid-media-video.liquid renders Shopify-hosted videos with
   autoplay:false and nothing in theme.js ever calls .play(), so product-card
   videos could only ever show their poster frame. (The external/YouTube
   branches in the same snippet were already autoplay:true, which is why only
   native Shopify videos looked broken.)

   WHY NOT JUST SET autoplay:true IN THE SNIPPET
   Measured on /collections/gifting-1: all 5 videos downloaded immediately,
   44.5 MB total, and the browser did NOT pause the 3 that were off-screen.
   The sources are HD-1080p 2.5Mbps clips used as ~160x208 hover thumbnails.

   BEHAVIOUR (by design, confirmed with Mihir 2026-07-29)
   - DESKTOP ONLY. Playback is bound to hover, so a clip is not fetched until
     the visitor actually hovers that card. preload stays 'none', so hover is
     what starts the download.
   - MOBILE / TOUCH: nothing is bound and no video is ever requested. Mobile
     is ~90% of traffic, so this keeps the heaviest asset class off the
     device entirely. Cards show their poster image, as before.
   - Pauses and rewinds on mouseleave so a re-hover starts from the top and
     no off-screen video keeps decoding.
   - Respects prefers-reduced-motion.

   ROLLBACK: delete this file and remove the matching <script> line from
   layout/theme.liquid. grid-media-video.liquid needs no change.
   ============================================================ */
(function () {
  var SEL = '.product__media__hover video, video.media-video';

  // Desktop only. The theme puts .no-touch on <html> for pointer devices.
  if (!document.documentElement.classList.contains('no-touch')) return;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function bindCard(v) {
    var card = v.closest('.product-grid-item__image') ||
               v.closest('.product__media__container') ||
               v.parentElement;
    if (!card || card.dataset.vhpBound) return;
    card.dataset.vhpBound = '1';

    card.addEventListener('mouseenter', function () {
      v.muted = true;          // keep muted so play() is always permitted
      v.playsInline = true;
      var p = v.play();        // preload='none' means this is what triggers the fetch
      if (p && typeof p.catch === 'function') {
        p.catch(function () { /* blocked or aborted: poster stays, no error surfaced */ });
      }
    });

    card.addEventListener('mouseleave', function () {
      if (!v.paused) v.pause();
      try { v.currentTime = 0; } catch (e) { /* not seekable yet */ }
    });
  }

  function bind(root) {
    (root || document).querySelectorAll(SEL).forEach(function (v) {
      if (v.dataset.vhpInit) return;
      v.dataset.vhpInit = '1';
      bindCard(v);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }

  // Collection pages paginate and filter over AJAX, so pick up cards added later.
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { bind(document); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
